<div class="zoom-buttons-container">
  <div
    class="zoom-button"
    [ngClass]="{ disabled: currentZoom >= maxZoom }"
    (click)="zoomInClick()"
    [soti-tooltip]="'map_zoom_out' | xsI18n"
    placement="left"
    delay="500"
  >
    <i class="ins-headline-3 insight-icon-zoom-in"></i>
  </div>
  <div class="zoom-divider"></div>
  <div
    class="zoom-button"
    [ngClass]="{ disabled: currentZoom <= minZoom }"
    (click)="zoomOutClick()"
    [soti-tooltip]="'map_zoom_out' | xsI18n"
    placement="left"
    delay="500"
  >
    <i class="ins-headline-3 insight-icon-zoomout"></i>
  </div>
</div>
